import { Component, OnInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { SelectItem } from 'primeng/api';

import {
  FacilityService, ReportsService, EquipmentService,
  SqacodeService, ModelService, ManufacturerService,
  MessageService
} from 'src/app/services';
import { DialogModule } from 'primeng/dialog';
import { emptyScheduled } from 'rxjs/internal/observable/empty';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import {AccessUserInfo } from 'src/app/models';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'bart-addequiment',
  templateUrl: './addequiment.component.html',
  styleUrls: ['./addequiment.component.scss'],

})
export class AddequimentComponent implements OnInit {


  public eqConfirmation:boolean=false;
  userId:number;
  bartRoleCode:string;
  userName:string
  bartRoleId:number;
  firstName:string=""
 lastName:string="";
 public  errormessage:string;
 public validationerror:boolean=false;

 public HideShowEquipmentSubType :boolean = false;
  public HideShowequipmentManufacturer :boolean = false;
  public HideShoweModel :boolean = false;
  public HideShowModelity :boolean = false;
  public HideShowCondition :boolean = false;
  public HideShowOrigin :boolean = false;
  public HideShowStatus :boolean = false;
  public HideShowDevice :boolean = false;


  closeResult: string;
  public isPMType:boolean = false;
  public userLocationDivision: SelectItem[];
  public DivisionName: any;
  public userLocationRegion: SelectItem[];
  public RegionName: any;
  public userLocationFacilities: SelectItem[];
  public selectedFacilityID: any;
  public modelItem: SelectItem[];
  public locData: any;
  public equipmentTypeId: any;
  public equipmentTypeItem: SelectItem[];
  public equipmentSubTypeItem: SelectItem[];
  public equipmentManufacturer: SelectItem[];
  public equipmentModel: SelectItem[];
  public equipmentModelity: SelectItem[];
  public equipmentCondition: SelectItem[];
  public equipmentOrigin: SelectItem[];
  public equipmentStatus: SelectItem[];
  public validationStaus: any;
  public ValidationData: any[] = [];
  public selectedequipmentid: number;
  public PMTyelist:SelectItem[];
  public disabledCombo: boolean = false;
  isShowDivIf = false;
  isDisabled=false;
  
  //TextBox and Colum header property for hinding and showing
  ShowNickName: boolean = false;
  ShowFunctiontxt: boolean = false;
  isShowNicknameHeader: boolean = false;
  isShowSoftwareColum: boolean = false;
  isShowAccuatrorColum: boolean = false;
  isShowFunctionalColum: boolean = false;
  ShowGeneralSoftware: boolean = false;
  ShowAccutator: boolean = false;
  showDivision :boolean= false;
  showFacility :boolean= false;
  showEqDetail :boolean= false;
  isActive:boolean=false;
  ipAddressColumn:boolean=false

  collapsedLocation :boolean= false;
  collapsedEqDetail :boolean= true;

  //Popup modal property for showing and hiding
  isShowNicknamePopup: boolean = false;
  isShowGSPopup: boolean = false;
  isShowACCPopup: boolean = false;
  isShowFunPopup: boolean = false;
  isShowInstalDatePopup: boolean = false;


  public EquipmentTypeId:string;
  public IsNicknameEnable: boolean;
  public selectedEquipmentTypeId: number;
  public equipmenttypeDesc: string;
  public EquipmentTypeDescription: any;
  public Deviceno: number;
  public DivisonName: number;
  public sn: string;
  public snvalidate: any;
  public orignalinstalldate: string
  public PMType: any;
  public LastPMDate: any;
  public description: any;
  public GeneralSoftware: any;
  public Count: number;
  public i: number;
  public beggingdate: any;
  public sn1: any;
  public modelidvalidate: any;
  public facilityNumber:string;
  public catalog: string;
  public selectedModelID: any;
  public selectedEquipmentStatusID: any

  public selectedEquipModalityID: number;
  public equipmentModalityId: any;
  public selectedConditionID: any;
  public selectedOriginID: any;
  public equipmentsubtypedescription: any;
  public modalpop:any;
  public selectedSN: string;
  public nickname: string;
  public IPAddress:string;
  public cot: any;
  public reportDetails: any;
  public acculatorversion: string;
  public generalsoftwareversion: string;
  public functionalversion: string;
  public machineversion: string;
  public machineipaddress: string;
  public equipmentTypeDescription: any;
  public Adresses: SelectItem[];
  public manufacturerId: any;
  public res: boolean;
  public checksoftwareversion: boolean;
  private isButtonVisible = true;
  public istextBoxVisible = true;
  public RowsNo: any;
  public reportstruct: any;
  EquipmentDeviceNo: boolean = false;
  DeviceSave: boolean = false;
  displayAdd: boolean = false;
  ErrorModal: boolean = false;
  ErroDialog: boolean = false;
  public installdateformat: any;
  public SaveRows:number;
  public MaxdateTime = new Date();
  title = 'appBootstrap';
  display: boolean = false;


  NicknameParam: any =
    {
      "GETVALIDATEMACHINENICKNAME": {
        FacilityMasterID: 0,
        MachineNickName: "",
        EquipmentTypeId: 0,
        EquipmentSubTypeId: 0
      }
    }


  ADDEQUIPMENTParam: any = {
  
    "ADDEQUIPMENT": {

      modelid: 0,
      originalInstallDate: "",
      equipmentStatusId: 0,
      EQUIPMENTSERIALNUMBER: 0,
      userid: 0,
      isNewFlag: 1,
      equipmentdesc: '',
      equipmentModalityId: 0,
      equipmentConditionId: 0,
      equipmentOriginId: 0,
      PMDATE: "",
      facilitymasterid: 0,
      MachineNickName: "",
      ActuatorVersion: "",
      FunctionalVersion: "",
      MachineIPAddress: "",
      GeneralSoftwareVersion: "",
    }
    ,
    "COMMONDETAILS":
    {
      MODELNAME:""

    },
    "CREATESERVICEREQUEST":
    {
      RequestSourceID	:0,	//int = NULL,
      UserID : 0,			//	int,
      FacilityMasterID :0,		//int,
      WorkTypeID :0,		//	int = NULL,
      EQUIPMENTID :0	,	//	int,
      SQACodeID :0	,		//	int,
      REQUESTDESCRIPTION :"",	//varchar(2000),
      SQASUBCODEID:0,		//	int = NULL,
      PMSEQUENCEID:0,	//	int = NULL

    },
    "WRITEALERT":
    {
      alertTypeId :0    // INT  = NULL
      ,alertObject :""    // VARCHAR(50) = NULL
      ,OBJECTID :  0     // INT = NULL
    ,targetUserId : 0   //INT	= NULL				
    ,facilityMasterId :0//INT	= NULL
    ,regionMasterId :0  //INT	= NULL
    ,divisionMasterId:0 //INT	= NULL
    ,alertPriorityId :0 //INT	= NULL
    ,dateActive  :  ""  // DATETIME
    ,dateExpires  :""   // DATETIME = NULL
    ,alertStatusId : 0   //INT 
    ,ALERTDETAIL  : ""  // VARCHAR(4000) = NULL	
    ,isActiveFlag	:0   //TINYINT
    ,userId  :  0      // INT = NULL

    },

    "GETFACILITYINFO":
    {
      "facilityMasterId": 0
    },
    "GETPMSEQUENCE":
    {
      //"SQASubCodeId": 0
    }


  };

  ValidateSNParam = {
    "VALIDATESERIAL":
    {
      serial: "",
      strippedSerial: 0,
      modelid: null
    }
  }

  public DeviceSaveConfirmation(){
    this.DeviceSave = false;
    this. userLocationDivision= [];
    this. DivisionName= '';
    this. userLocationRegion= [];
    this. RegionName= '';
    this. userLocationFacilities= [];
    this. selectedFacilityID= null;
    this. modelItem= [];
    this. locData= null;
    this. equipmentTypeId= null;
    this. equipmentTypeItem= [];
    this. equipmentSubTypeItem= [];
    this. equipmentManufacturer= [];
    this. equipmentModel= [];
    this. equipmentModelity= [];
    this. equipmentCondition= [];
    this. equipmentOrigin= [];
    this. equipmentStatus = [];
    this. validationStaus = null;
    this. ValidationData = [];
    this. selectedequipmentid= 0;
    this. PMTyelist = [];
    this. disabledCombo = false;
   
     this.isShowDivIf = false;
    
    this.ShowNickName = false;
    this.ShowFunctiontxt = false;
    this.isShowNicknameHeader = false;
    this.isShowSoftwareColum = false;
    this.isShowAccuatrorColum = false;
    this.isShowFunctionalColum = false;
    this.ShowGeneralSoftware = false;
    this.ShowAccutator = false;
    this.showDivision = false;
    this.showFacility = false;
    this.showEqDetail = false;
   
    this.collapsedLocation = false;
    this.collapsedEqDetail = true;
    
    this.isShowNicknamePopup = false;
    this.isShowGSPopup = false;
    this.isShowACCPopup = false;
    this.isShowFunPopup = false;
    this.isShowInstalDatePopup = false;
  
  
    this. IsNicknameEnable;
    this. selectedEquipmentTypeId= 0;
    this. equipmenttypeDesc= '';
    this. EquipmentTypeDescription= null;
    this. Deviceno= 0;
    this. DivisonName= 0;
    this. sn= '';
    this. snvalidate= null;
    this. orignalinstalldate= ''
    this. PMType= null;
    this. LastPMDate= null;
    this. description= null;
    this. GeneralSoftware= null;
    this. Count= 0;
    this. i= 0;
    this. beggingdate= null;
    this. sn1= null;
    this. modelidvalidate= null;
  
    this. catalog= '' ;
    this. selectedModelID= null;
    this. selectedEquipmentStatusID= null
  
    this. selectedEquipModalityID= 0;
    this. equipmentModalityId= null;
    this. selectedConditionID= null;
    this. selectedOriginID= null;
    this. equipmentsubtypedescription= null;
    this. selectedSN= '';
    this. nickname= '';
    this. cot= null;
    this. reportDetails= null;
    this. acculatorversion= '';
    this. generalsoftwareversion= '';
    this. functionalversion= '';
    this. machineversion= '';
    this. machineipaddress= '';
    this. equipmentTypeDescription= null;
    this. Adresses= [];
    this. manufacturerId= null;
    this. res;
    this. checksoftwareversion;
    this.isButtonVisible = true;
    this.istextBoxVisible = true;
    this. RowsNo = '';
    this. reportstruct;
    this.validationerror=false
    this.EquipmentDeviceNo = false;
    this.DeviceSave = false;
    this.displayAdd = false;
    this.ErrorModal = false;
    this.ErroDialog = false;
    this. installdateformat;
    this. SaveRows;
    this.title = 'appBootstrap';
    this.display = false;
 

    this. HideShowEquipmentSubType = false;
    this. HideShowequipmentManufacturer  = false;
    this. HideShoweModel = false;
    this. HideShowModelity  = false;
    this. HideShowCondition = false;
    this. HideShowOrigin  = false;
    this. HideShowStatus  = false;
    this. HideShowDevice = false;

    this.reloadData();

  }
  async ValidateService(VALIDATESERIAL) {
    let result: any[]=[];

    await this._EquipmentService.validateSerialSync(JSON.stringify(VALIDATESERIAL))
      .then((ValidateResponse: any) => {

        if (ValidateResponse.valSerial.length > 0) {
          result = ValidateResponse.valSerial;
        }
        else {
          result = [];
        }
      },
      );

    return result;

  }

  async ValidateSerialNofromDB() {
    let validate: any[]=[];

    this.ValidateSNParam.VALIDATESERIAL.modelid = this.selectedModelID.value;
    for (let k = 0; k < this.addresses.length; k++) {

      this.ValidateSNParam.VALIDATESERIAL.serial = this.addresses[k].sn;
      this.ValidateSNParam.VALIDATESERIAL.strippedSerial = this.addresses[k].sn;
      validate = await this.ValidateService(this.ValidateSNParam);
      this.addresses[k].DbValidation = validate;
      if (validate) {
        this.ValidationData.push("serial number ("+this.addresses[k].sn+") already exist.")
      }

    }


    return validate;

  }

  async ValidateServiceMachineIPAddress(VALIDATEMACHINEIPADDRESS) {
    var VALIDATEMACHINEIPADDRESSPARAM={
      "VALIDATEMACHINEIPADDRESS": {
          "MachineIPAddress":VALIDATEMACHINEIPADDRESS
          
      }
  }
    let result: boolean = false;
    await this._EquipmentService.validateMachineIPAddressSync(JSON.stringify(VALIDATEMACHINEIPADDRESSPARAM))
      .then((ValidateResponse: any) => {
        if (ValidateResponse.length > 0) {
          result = true;
          this.ValidatedIPadressDetail = ValidateResponse;
        } else {
          result = false;
          this.ValidatedIPadressDetail = null;
        }
      }, );

    return result;

  }

public ValidatedIPadressDetail: any=null;
  async ValidateMachineNickName() {
    
    let NickNamevalidate: boolean;

    this.NicknameParam.GETVALIDATEMACHINENICKNAME.FacilityMasterID = this.selectedFacilityID.value;
    this.NicknameParam.GETVALIDATEMACHINENICKNAME.EquipmentTypeId = this.selectedequipmentid;
    this.NicknameParam.GETVALIDATEMACHINENICKNAME.EquipmentSubTypeId = this.getManufacturerParm.GETMANUFACTURERSFORADDEQUIP.equipmentSubTypeId;
    for (let k = 0; k < this.addresses.length; k++) {

      this.NicknameParam.GETVALIDATEMACHINENICKNAME.MachineNickName = this.addresses[k].nickname;
      NickNamevalidate = await this.ValidateServiceNickName(this.NicknameParam);

      if (NickNamevalidate) {
        this.ValidationData.push("Nickname Already exist");
      }

    }


    return NickNamevalidate;

  }

  async ValidateServiceNickName(GETVALIDATEMACHINENICKNAME) {
    let result: boolean = false;

    
    await this._EquipmentService.validateMachineNickNameSync(JSON.stringify(GETVALIDATEMACHINENICKNAME))
      .then((ValidateResponse: any) => {
        
        if (ValidateResponse.machineNickName.length > 0) {

          result = true;
        }
        else {
          result = false;
        }
      },
      );

    return result;

  }


 checkIfArrayIsUnique(arr:any) {
  let map = {}, i, size;
  for (i = 0, size = arr.length; i < size; i++){
      if (map[arr[i].sn]){
          return false;
      }
      map[arr[i].sn] = true;
  }
  return true;
}

  public nextButtonErrorMessage:string="";
  async showDialog() 
  {
    
    this.nextButtonErrorMessage=""
    var regExIPAddress = /^([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/;
    this.cols = [];
    this.cols.push( "SN/IntID");
    this.cols.push( "Description");
    if(this.isShowNicknameHeader) this.cols.push( "Nickname");
    if(this.ipAddressColumn) this.cols.push( "IP Address");
    if(this.isShowSoftwareColum) this.cols.push( "Software Version");
     if(this.isShowAccuatrorColum) this.cols.push( "Module 1");
     if(this.isShowFunctionalColum) this.cols.push( "Module 2");
     this.cols.push( "Install Date");
    if ((this.selectedOriginID.value == 2 && this.selectedConditionID.value == 2) || (this.selectedOriginID.value == 2 && this.selectedConditionID.value == 3)) {
      this.isPMType = true;
      this.cols.push( "PM Type");
      this.cols.push( "Last PM Date");
    }
    else
    {
      this.isPMType = false;
    }

    

    this.ValidationData = [];
    let IsArrayUnique = this.checkIfArrayIsUnique(this.addresses);
    let deviceErrors:string=""; 
    let generalError:string="";

    let isRowValid:boolean=true
    let isNickNameValid:boolean=true;
    var invalidSerials = [];
    var invalidNickNames=[];
    var invalidIpAddresses=[]
    let count = 1
    for (let j = 0; j < this.addresses.length; j++) {
      
      let invalidSerial = 0;
      let invalidNickName=0;
      let invalidIpAddress=0;

      var serialNum=this.addresses[j].sn
      var nickname=this.addresses[j].nickname
      var IPAddress=this.addresses[j].IPAddress
      if (serialNum == '' || serialNum== undefined || serialNum == null) 
      {
        deviceErrors+="<div class='errorDiv'>Please enter a serial number.</div>"
        isRowValid=false
      }
      else 
      {
        
        let count2=1;
        for (let i = 0, size = this.addresses.length; i < size; i++)
        {
            var thisSerial = this.addresses[i].sn
            if (thisSerial == serialNum && count != count2) 
            {
              if ( invalidSerials.filter(x=>x==count).length<=0 ) 
              {
                  invalidSerials.push(count);
              }
              invalidSerial = 1;
            }
            count2++
         }
         if (invalidSerial == 0) 
         {
          
            this.ValidateSNParam.VALIDATESERIAL.modelid = this.selectedModelID.value;
            this.ValidateSNParam.VALIDATESERIAL.serial = this.addresses[j].sn;
            this.ValidateSNParam.VALIDATESERIAL.strippedSerial = this.addresses[j].sn;
            let validate = await this.ValidateService(this.ValidateSNParam);
            if(validate!=null && validate.length>0)
            {
              deviceErrors+="<div>Serial number already exists; please verify and re-enter.</div>";
              deviceErrors+="<div>"+validate[0].facilityNumber+"-"+validate[0].facilityName+"("+this.addresses[j].sn+")</div><br/>";
              isRowValid=false;
            }
            
         }

       }

       //#region NickName
       if (this.ShowNickName && this.isActive) 
       {
          if (this.addresses[j].nickname != undefined && this.addresses[j].nickname != "")
          {
            if (!((this.addresses[j].nickname >= 1 && (this.addresses[j].nickname) <= 999))) 
            {
              deviceErrors+="<div>Equipment Nickname should be within the range of 1 - 999.</div>"
              isRowValid=false
              invalidNickName = 1;
              
            }
            let count2=1;
            for (let i = 0, size = this.addresses.length; i < size; i++)
            {
                var thisNickName = this.addresses[i].nickname
                if (thisNickName == nickname && count != count2) 
                {
                  if (invalidNickNames.filter(x=>x==count).length<=0 ) 
                  {
                    invalidNickNames.push(count);
                  }
                  invalidNickName = 1;
                }
                count2++
             }
             if (invalidNickName == 0) 
              {
                  this.NicknameParam.GETVALIDATEMACHINENICKNAME.FacilityMasterID = this.selectedFacilityID.value;
                  this.NicknameParam.GETVALIDATEMACHINENICKNAME.EquipmentTypeId = this.selectedequipmentid;
                  this.NicknameParam.GETVALIDATEMACHINENICKNAME.EquipmentSubTypeId = this.getManufacturerParm.GETMANUFACTURERSFORADDEQUIP.equipmentSubTypeId;
                  this.NicknameParam.GETVALIDATEMACHINENICKNAME.MachineNickName = this.addresses[j].nickname;
                  let NickNamevalidate = await this.ValidateServiceNickName(this.NicknameParam);
                  if(NickNamevalidate)
                  {
                    deviceErrors+="<div>Nickname already exists; please verify and re-enter.</div>"
                    deviceErrors+="<div>Existing Nickname:"+nickname+"</div><br/>"
                    isRowValid=false
                  }
                  
              }
          }
        }
        //#endregion
      //#region  IP Address
      
      if(this.ipAddressColumn && this.isActive)
      {
         if(IPAddress!=null && IPAddress!=undefined && this.addresses[j].IPAddress.length>0)
         {
            
            if (!regExIPAddress.test(this.addresses[j].IPAddress)) 
            {
                deviceErrors+="<div class='errorDiv'>Equipment IP Address is not valid.</div>"
                isRowValid=false
                invalidIpAddress = 1;
            }

            let count2=1;
            for (let i = 0, size = this.addresses.length; i < size; i++)
            {
                var thisIPAddress = this.addresses[i].IPAddress
                if (thisIPAddress == IPAddress && count != count2) 
                {
                  if (invalidIpAddresses.filter(x=>x==count).length<=0 ) 
                  {
                    invalidIpAddresses.push(count);
                  }
                  invalidIpAddress = 1;
                }
                count2++
              }
              if (invalidIpAddress == 0) 
              {
                this.ValidatedIPadressDetail = null;
                let validate = await this.ValidateServiceMachineIPAddress(IPAddress);
                if(validate)
                {
                  let finalText = '';
                  if(this.ValidatedIPadressDetail!=null && this.ValidatedIPadressDetail.length>0)
                      finalText  = this.ValidatedIPadressDetail[0].FacilityNumber+"-"+this.ValidatedIPadressDetail[0].FacilityName+ " ("+this.ValidatedIPadressDetail[0].EquipmentSerialNumber+")"; 
                  deviceErrors+="<div>IP address already exists; please verify and re-enter. </br>Existing IP Address:"+this.addresses[j].IPAddress+"</div>"
                  deviceErrors+="<div><br/>" + finalText + "</div><br/>"
                  isRowValid=false

                }
                
              }
          }
       }
      //#endregion
      if (this.addresses[j].Installdate == undefined || this.addresses[j].Installdate == "" || this.addresses[j].Installdate == "null") 
      {
        let insDate=this.addresses[j].Installdate
        let isDateValid=true;
        if(insDate==null || insDate==undefined || insDate=="")
        {
          deviceErrors+="<div>Please enter a valid Original Install Date</div>";
          isDateValid=false;
          isRowValid=false;
        }
        if(isDateValid)
        {
          var currDate = new Date();
          var   otherDate:Date = new Date(insDate);
          if ((otherDate.valueOf() - currDate.valueOf() > 0) && (otherDate.valueOf() - currDate.valueOf() < 366)) 
          {
            deviceErrors+="<div>The date required is the device's original installation date.\n\nPlease verify the date entered, and click OK to confirm, or Cancel to discard this entry.</div>";
            isRowValid=false
          }
        }
      }
      if(this.isPMType)
      {
        let pmType=this.addresses[j].PMType;
        let LastPMDate=this.addresses[j].LastPMDate
        if(pmType==null || pmType==undefined|| pmType=="")
        {
          deviceErrors+="<div>Please select a PM Type.</div>";
          isRowValid=false;
        }
        if(LastPMDate==null || LastPMDate==undefined || LastPMDate=="")
        {
          let confirmBtn = '<input style="width:50px" type="button" class="ui-button btnAddEquipmentErrDialog" name="pmDateOK" id="pmDateOK_'+j+'_OK" value="OK" class="errorButtons"/> <input type="button" name="pmDateCANCEL" style="width:60px" class="ui-button btnAddEquipmentErrDialog" id="pmDateCANCEL_'+j+'_Cancel" value="Cancel" class="errorButtons"/>';
          let confirmVal = this.addresses[j].alertFlagField;
          if (confirmVal != 1) 
          {
            deviceErrors+="<div>PM Date was not specified so a PM may be required.\n Click OK to confirm or click Cancel to edit." +confirmBtn + "</div>";
            isRowValid=false;
          }
        }
      }
      if (this.ShowGeneralSoftware)
      {
        if (this.addresses[j].GeneralSoftware == '' || this.addresses[j].GeneralSoftware == undefined || this.addresses[j].GeneralSoftware == null)
         {
            //this.ValidationData.push("Please enter software version.")
            deviceErrors+="<div>Please enter Software Version.</div>"
            isRowValid=false
         }
         else if(this.addresses[j].GeneralSoftware.length > 10)
         {
          deviceErrors+="<div>Equipment Software Versions should be within 10 characters.</div>"
          isRowValid=false
         }
      }    

      if (this.ShowAccutator) 
      {
        if (this.addresses[j].Accutator == '' || this.addresses[j].Accutator == undefined || this.addresses[j].Accutator == null) 
        {
           deviceErrors+="<div>Please enter Module 1.</div>"
           isRowValid=false
        }
        else if(this.addresses[j].Accutator.length > 10)
        {
          deviceErrors+="<div>Equipment Module 1 should be within 10 characters.</div>"
          isRowValid=false
        }
      }

      if (this.ShowFunctiontxt) 
      {
        if (this.addresses[j].Functional == '' || this.addresses[j].Functional == undefined || this.addresses[j].Functional == null) 
        {
          deviceErrors+="<div class='errorDiv'>Please enter Module 2.</div>"
          isRowValid=false
        }
        else if(this.addresses[j].Functional.length > 10)
         {
          deviceErrors+="<div>Equipment Module 2 should be within 10 characters.</div>"
          isRowValid=false
         }
      }

      this.addresses[j].errorClass="success";
      if(deviceErrors.length>0)
      {
        this.nextButtonErrorMessage+="<div><b>Row "+count+"</b></div>"+deviceErrors
        this.nextButtonErrorMessage+="<br/><br/>";
        this.addresses[j].errorClass="validationError";
      }
      deviceErrors="";
        count++;
     
    }
    if (invalidSerials.length) 
    {
      generalError="<div>Duplicate serial numbers; please verify and re-enter these serial numbers: " + invalidSerials.join()+"</div>";
    }
    if (invalidNickNames.length) 
    {
      generalError+="<div>Duplicate Nickname; please verify and re-enter these Nicknames: " + invalidNickNames.join()+"</div>";
    }
    if (invalidIpAddresses.length) 
    {
      generalError+="<div>Duplicate IP Addresses; please verify and re-enter these IP addresses: " + invalidIpAddresses.join()+"</div>";
    }


    
    if(isRowValid==false)
    {
      if(generalError!=null && generalError.length>0)
      this.nextButtonErrorMessage=generalError+"<br/><br/>"+ this.nextButtonErrorMessage;
    }
    else if(generalError.length>0 &&  isRowValid)
    {
      this.nextButtonErrorMessage=generalError;
      isRowValid=false
    }
    if(isRowValid==false)
    {
      this.nextButtonErrorMessage=this.nextButtonErrorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
      this.ErroDialog=true
      setTimeout(() => {
        this.errorDialogButtonClicked();
      }, 200);
    }
    else
    {
      this.ErroDialog=false
      this.display = true;
    }
  }


  public addresses: any[] = [{
    id: "",
    sn: "",
    description: "",
    nickname: "",
    IPAddress:"",
    GeneralSoftware: "",
    Accutator: "",
    Functional: "",
    Installdate: "",
    PMType: "",
    LastPMDate: "",
    DbValidation: true,
    alertFlagField:0,
    errorClass:""
  }];

  
  public cols: any = [
    "SN/IntID",
    "Description",
    "Nickname",
    "IP Address",
    "General Software",
    "Acuator",
    "Functional",
    "OrignalInstallDate",
  ];

  addAddress(RowsNo: number) {
    this.addresses = [];
    for (let ii = 0; ii <= this.RowsNo - 1; ii++) {
      this.addresses.push({

        recordNo:ii+1,
        id: "",
        sn: "",
        description: "",
        nickname: "",
        IPAddress: "",
        GeneralSoftware: "",
        Accutator: "",
        Functional: "",
        Installdate: "",        
        PMType: "",
        PMTypeDescription: "",
        LastPMDate: "",
        DbValidation: ''
      });
    }
  }



  removeAddress(i: number) {
    
    this._confirmationService.confirm({
      message: 'Are you sure you want to remove the selected row?',
      accept: () => {              
          this.addresses.splice(i, 1);
          this.Count = i;
        },
      reject: () => {              
        this.eqConfirmation=false;
      }
    });
    

  }
  logValue() {
    
  }





  GETFACILITYINFOParam = {

  }

  
  getManufacturerParm = {
    "GETMANUFACTURERSFORADDEQUIP": {
      "equipmentTypeId": 0,
      "equipmentSubTypeId":0
    }
  }

  getModelsParam =
    {
      "GETMODELSFORADDEQUIP":
      {
        "equipmentTypeId": 0,
        "manufacturerId": 0, 
        "equipmentSubTypeId": 0
      }
    }

  getModelsParamList =
    {
      "GETMODELS":
      {
        equipmentTypeId: null,
        manufacturerId: 0,
        modelId: 0,
        SearchTerm: null,
        modelsOnly: null
      }
    }
  getEquipmentSubTypeParam =
    {
      "GETEQUIPMENTSUBTYPES":
      {
        equipmenttypeid: 0
      }
    }

      constructor(private _FacilityService: FacilityService,
    private _Modelservice: ModelService,
    private _EquipmentService: EquipmentService,
    private _ManufacturerService: ManufacturerService,
    private messageService: MessageService,
    private router:Router,
    private _confirmationService: ConfirmationService,
    private changeDetectorRef: ChangeDetectorRef, private elementRef:ElementRef,) { 

      let userInfo = AccessUserInfo.getUserInfo();
      if(userInfo!=null)
      {
        this.userId=userInfo.userId
        this.bartRoleCode=userInfo.bartRoleCode
        this.userName=userInfo.userName
        this.bartRoleId=userInfo.bartRoleId
        // this.firstName=userInfo.firstName;
        // this.lastName=userInfo.lastName;
        
      }

    }


  ngOnInit() 
  {
   
    this.reloadData();
  }

  public reloadData()
  {
    this.GetUserLocations();
    this.populateEquipmentType();
    this.populateEquipmentStatus();
    this.populateEquipmentOrigin();
    this.populateEquipmentCondition();
    this.populateEquipmentModality();
    
    this.PMTyelist = [];
    // this.PMTyelist.push({label:'Q - Quarter Annual PM',value:"2"});
    // this.PMTyelist.push({label:'S - Semi-Annual PM',value:"3"});
    // this.PMTyelist.push({label:'A - Annual PM',value:"4"});
    // this.PMTyelist.push({label:'Monthly',value:"10"});
    // this.PMTyelist.push({label:'Unknown/None',value:"12"});       

  }
  GetPMTye() {
  
    let pMTypes = {
    "GETSQASUBCODEUSEDAQUIRED": {
      modelId: this.selectedModelID.value
      }        
    }
    this._EquipmentService.getPMTypes(JSON.stringify(pMTypes))
      .subscribe((getPMTypesResponse: any) => {
        this.PMTyelist = [];
        if (getPMTypesResponse.length > 0) {
         
          for (let c of getPMTypesResponse) {
            // this.PMTyelist.push({ label: c.SQASubDescription, value: c.SQASubCodeID });
            this.PMTyelist.push({ label: c.PMSequenceDescription, value: c. PMSequenceID});
          }          
        }
      });
  }

public PMTypelistChange(evt,itemID:any){
  if(evt.value !=null){
      let item: any = this.addresses.find(s => s.recordNo == itemID);
      if(item!=null) item.PMTypeDescription=evt.label;
}

}
  GetUserLocations() {
    let getLocationParam = {
      "GETUSERLOCATIONS": {
        LOCATION_ID_LIST: null,
        USERNAME: this.userName,
      },
      "GETUSERLOCATIONS2": {
        USERNAME: this.userName,
      }
    }


    if (getLocationParam != null) {
      
      this._FacilityService.getUserLocations(JSON.stringify(getLocationParam))
        .subscribe((allUserLocationsResponse: any) => {
          this.locData = allUserLocationsResponse;
          this.userLocationDivision = [];
          this.userLocationRegion = [];
          this.userLocationFacilities = [];
          if (allUserLocationsResponse.facilities.length > 0) {
            for (let c of allUserLocationsResponse.facilities) {
              this.userLocationFacilities.push({ label: c.FacilityName, value: c.FacilityMasterID });
            }
          }

          if (allUserLocationsResponse.divisions.length > 0) {
            for (let c of allUserLocationsResponse.divisions) {
              this.userLocationDivision.push({ label: c.DivisionName, value: c.DivisionMasterID });
            }
          }

          if (allUserLocationsResponse.regions.length > 0) {
            for (let c of allUserLocationsResponse.regions) {
              this.userLocationRegion.push({ label: c.RegionName, value: c.RegionMasterID });;
            }
          }
        }, (respose: Response) => {
          this.userLocationDivision = [];
          this.userLocationRegion = [];
          this.userLocationFacilities = [];
        },
        
        );
    }

  }


  populateDivisions() {
    this.userLocationDivision = [];
    if (this.locData != null && this.locData.divisions.length > 0) {
      this.userLocationDivision = []
     
      for (let c of this.locData.divisions) {
        this.userLocationDivision.push({ label: c.DivisionName, value: c.DivisionMasterID });
      }
    }
  }

  populateRegions(evt) {
    this.RegionName = '';

    this.userLocationRegion = [];
    this.showDivision = false;
     if(evt!=null && evt.value !=null)
      this.showDivision = true;
      else
      this.showDivision = false;
    if (evt!=null && this.locData.regions.length > 0) {
     
      for (let c of this.locData.regions) {
        if (c.DivisionMasterID === evt.value) {
          this.userLocationRegion.push({ label: c.RegionName, value: c.RegionMasterID });
        }
      }
    }
  }

  populateFacilities(evt) {

    this.selectedFacilityID = 0;

    this.userLocationFacilities = [];
    this.showFacility = false;
    if(evt.value !=null)
    {
      this.showFacility = true;     
    }

    if (this.locData.facilities.length > 0) {
      
      for (let c of this.locData.facilities) {
        if (c.RegionMasterID === evt.value) {
          this.userLocationFacilities.push({ label: c.FacilityDisplayName, value: c.FacilityMasterID });;
        }
      }
    }
  }

  showHideEqDetail(evt) {
    
    this.showEqDetail = false;
    this.collapsedLocation= false;
    this.collapsedEqDetail= true;
    if(evt.value !=null)
    {
      this.showEqDetail = true;
      this.collapsedLocation= false;
      this.collapsedEqDetail = false;
    }
    if (this.locData.facilities.length > 0) {
      if(!this.locData.facilities.find(x=>x.value==this.selectedFacilityID.value))
      {
        this.facilityNumber=this.locData.facilities.find(x=>x.FacilityMasterID==this.selectedFacilityID.value).FacilityNumber
      }
    }
  }

  prepareNicknameSoftwareModels() {
    this.getModelsParamList.GETMODELS.manufacturerId = this.equipmentTypeId.value;
    var request = this.getModelsParamList;
    this._Modelservice.getModels(JSON.stringify(request))

      .subscribe((getEquipmentModelResponse: any) => {
        
        if (getEquipmentModelResponse.models.length > 0) {
          this.isShowDivIf = true;
          this.reportDetails = [];
          this.reportstruct = [];
          var input: any;
          var r: any;
          var reportFields: any;
          var data: any;
          var nickNameManagerObj = {};          
          let modelDetails:any=getEquipmentModelResponse.models.find(x=>x.modelid==this.selectedModelID.value);
          
          if (modelDetails.IsNickNameEnabled && this.EquipmentTypeId=="1") {
            this.IsNicknameEnable = true;
            this.isShowNicknameHeader = true;
            this.ShowNickName = true;
                      
          }
        
          else{
            this.IsNicknameEnable = false;
            this.isShowNicknameHeader = false;
            this.ShowNickName = false;
            this.isShowNicknamePopup = false;

          }          
          if(modelDetails.IsIpAddressEnabled && this.EquipmentTypeId=="1")
          {
            this.ipAddressColumn = true;
          }
          else
          {
            this.ipAddressColumn = false;
          }          
          r = modelDetails.SoftwareVersion;
          if (modelDetails.SoftwareVersion != null) {

            let  isSoftwareVersion = false, isAccuatror = false, isFunctional = false;
             isSoftwareVersion = modelDetails.SoftwareVersion.toString().includes('1_1');
             isAccuatror =   modelDetails.SoftwareVersion.toString().includes('2_1');
             isFunctional =  modelDetails.SoftwareVersion.toString().includes('3_1');

            this.checksoftwareversion = isSoftwareVersion;
            this.isShowSoftwareColum = isSoftwareVersion;
            this.isShowAccuatrorColum = isAccuatror;
            this.isShowFunctionalColum = isFunctional;
            this.ShowFunctiontxt = isFunctional;
            this.ShowGeneralSoftware = isSoftwareVersion;
            this.ShowAccutator = isAccuatror;
            this.isShowGSPopup = true;
            this.isShowACCPopup = true;
            this.isShowFunPopup = true;
          }
          else
          {
            this.checksoftwareversion = false;
            this.isShowSoftwareColum = false;
            this.isShowAccuatrorColum = false;
            this.ShowFunctiontxt = false;
            this.isShowFunctionalColum = false;
            this.ShowGeneralSoftware = false;
            this.ShowAccutator = false;
            this.isShowGSPopup = false;
            this.isShowACCPopup = false;
            this.isShowFunPopup = false;

          }
          let requireNickName = getEquipmentModelResponse.models.IsIpAddressEnabled;
          var arrayOptions = getEquipmentModelResponse.models.SoftwareVersion;
        }
      },
      (respose: Response) => {
            
      }
      );

  }


  populateEquipmentModels(evt) {
    this.selectedModelID = 0;
    if( evt.value>0) this.HideShoweModel = true; else this.HideShoweModel=false;
    this.getModelsParam.GETMODELSFORADDEQUIP.manufacturerId = evt.value;
    this.getModelsParam.GETMODELSFORADDEQUIP.equipmentTypeId = this.EquipmentTypeDescription.value;
    this.getModelsParam.GETMODELSFORADDEQUIP.equipmentSubTypeId = this.equipmentsubtypedescription.value;
    var request = this.getModelsParam;
    this._Modelservice.getModelsForAddEquip(JSON.stringify(request))
      .subscribe((EquipmentModelResponse: any) => {
        this.equipmentModel = [];
        if (EquipmentModelResponse.models.length > 0) {

          for (let c of EquipmentModelResponse.models) {
            this.equipmentModel.push({ label: c.modelnumber, value: c.modelid });
          }
        }
      },
      (respose: Response) => {
      
      }
      );
  }

  populateEquipmentType() {
    this._EquipmentService.getEquipmentTypes()
      .subscribe((getEquipmentResponse: any) => {
        this.equipmentTypeItem = [];
        if (getEquipmentResponse.equipmentType.length > 0) {
         
          for (let c of getEquipmentResponse.equipmentType) {
            this.equipmentTypeItem.push({ label: c.EquipmentTypeDescription, value: c.EquipmentTypeId });
          }
        }
      });
  }
  populateEquipmentStatus() {
    this._EquipmentService.getEquipmentStatus()
      .subscribe((EquipmentStausResponse: any) => {
        this.equipmentStatus = [];
        if (EquipmentStausResponse.status.length > 0) {
          
          for (let c of EquipmentStausResponse.status) {
            this.equipmentStatus.push({ label: c.EquipmentStatusDescription, value: c.EquipmentStatusId });
          }
        }
      });
  }

  populateEquipmentManufacturer() {
    var request = this.getManufacturerParm;
    this._ManufacturerService.getManufacturersForAddEquip(JSON.stringify(request))
      .subscribe((Response: any) => {
        this.equipmentManufacturer = [];
        if (Response.manufacturers.length > 0) {
          
          for (let c of Response.manufacturers) {
            this.equipmentManufacturer.push({ label: c.manufacturerName, value: c.manufacturerId });
          }
        }
      });
  }
  populateEquipmentManufacturer1(evt) {
    this.equipmentTypeId = 0;

    this.getManufacturerParm.GETMANUFACTURERSFORADDEQUIP.equipmentSubTypeId = evt.value;
    if( evt.value>0) this.HideShowequipmentManufacturer  = true; else this.HideShowequipmentManufacturer =false;
    var request = this.getManufacturerParm;
    this._ManufacturerService.getManufacturersForAddEquip(JSON.stringify(request))
      .subscribe((Response: any) => {
        this.equipmentManufacturer = [];
        if (Response.manufacturers.length > 0) {
         
          for (let c of Response.manufacturers) {
            this.equipmentManufacturer.push({ label: c.manufacturerName, value: c.manufacturerId });
          }
        }
      });
  }

  populateEquipmentModality() {
    this._EquipmentService.getEquipmentModality()
      .subscribe((ModalityResponse: any) => {
        this.equipmentModelity = [];
        if (ModalityResponse.equipmentModality.length > 0) {
          
          for (let c of ModalityResponse.equipmentModality) {
            this.equipmentModelity.push({ label: c.ModalityDescription, value: c.EquipmentModalityId });
          }
        }
      });
  }

 
  
  
  StatusChanged(evt) {
    
    this.EquipmentTypeId=evt.value;
    if( evt.label!='') this.HideShowDevice = true; else this.HideShowDevice=false;
  }
  

  OriginChanged(evt) {
    if( evt.value>0) this.HideShowStatus = true; else this.HideShowStatus=false;
  }
  
  ConditionChanged(evt) {
    if( evt.value>0) this.HideShowOrigin = true; else this.HideShowOrigin=false;
  }
  
  ModelityChanged(evt) {
    if( evt.value>0) this.HideShowCondition = true; else this.HideShowCondition=false;
  }
  ModelChanged(evt) {
    if( evt.value>0) this.HideShowModelity = true; else this.HideShowModelity=false;
    this.GetPMTye();
  }

  populateEquipmentSubType(evt) {
    let vv = this.EquipmentTypeDescription
    this.equipmentsubtypedescription = '';
    this.selectedequipmentid = evt.value;
    if( evt.value>0) this.HideShowEquipmentSubType = true; else this.HideShowEquipmentSubType=false;
    this.getEquipmentSubTypeParam.GETEQUIPMENTSUBTYPES.equipmenttypeid = evt.value;
    var request = this.getEquipmentSubTypeParam;
    this._EquipmentService.getEquipmentSubtypes(JSON.stringify(request))
      .subscribe((equipmentSubTypeRespose: any) => {
        this.equipmentSubTypeItem = [];

        if (equipmentSubTypeRespose.equipmentSubType.length > 0) {
         // equipmentSubTypeRespose.equipmentSubType.push({ label: "", value: null });
          
          for (let c of equipmentSubTypeRespose.equipmentSubType) {
            this.equipmentSubTypeItem.push({ label: c.EquipmentSubTypeDescription, value: c.EquipmentSubTypeId });
          }
        }
      });
  }

  populateEquipmentCondition() {
    this._EquipmentService.getEquipmentConditions()
      .subscribe((EquipmentConditionResponse: any) => {
        this.equipmentCondition = [];
        if (EquipmentConditionResponse.conditions.length > 0) {
          
          for (let c of EquipmentConditionResponse.conditions) {
            this.equipmentCondition.push({ label: c.EquipmentConditionDescription, value: c.EquipmentConditionId });
          }
        }
      });
  }
  populateEquipmentOrigin() {
    this._EquipmentService.getEquipmentOrigins()
      .subscribe((EquipmentOriginResponse: any) => {
        this.equipmentOrigin = [];
        if (EquipmentOriginResponse.origins.length > 0) {
          
          for (let c of EquipmentOriginResponse.origins) {
            this.equipmentOrigin.push({ label: c.EquipmentOriginDescription, value: c.EquipmentOriginId });
          }
        }
      });
  }

  EquipmentSpecificInfo() {
    this.DivisonName;
    this.RowsNo;
    let item: SelectItem = this.userLocationDivision.find(s => s.value == this.userLocationDivision);
    let item1 = this.userLocationDivision
    this.addAddress(this.RowsNo); 
  }
  public CloseEquipmentInfo() {   
    this.eqConfirmation=true;
          this._confirmationService.confirm({
            message: 'All of your data will be lost. Are you sure you want to close the panel?',
            accept: () => {              
              this.isShowDivIf = false;
              this.istextBoxVisible = true;
              this.disabledCombo = false;
              this.eqConfirmation=false;
            },
            reject: () => {              
              this.eqConfirmation=false;
            }

          });
          
    // if (confirm("All your data will be lost. Are you sure you want to close the panel."))
    // {
    //   this.isShowDivIf = !this.isShowDivIf;
    //   this.istextBoxVisible = true;
    //   this.disabledCombo = false;
    // }
  }

  gettextboxvalue() {
    for (let cot = 0; cot < this.Deviceno - 1; cot++) {
      this.sn = this.addresses[cot].sn
    }
  }


  saveAddEqupment() {
        for (let cot = 0; cot < this.addresses.length; cot++) 
        {
      this.SaveRows=this.addresses.length;
      this.ADDEQUIPMENTParam.ADDEQUIPMENT.modelid = this.selectedModelID.value;
      this.ADDEQUIPMENTParam.ADDEQUIPMENT.equipmentStatusId = this.selectedEquipmentStatusID.value;
      this.ADDEQUIPMENTParam.ADDEQUIPMENT.equipmentModalityId = this.equipmentModalityId.value;
      this.ADDEQUIPMENTParam.ADDEQUIPMENT.equipmentConditionId = this.selectedConditionID.value;
      this.ADDEQUIPMENTParam.ADDEQUIPMENT.equipmentOriginId = this.selectedOriginID.value;
      this.ADDEQUIPMENTParam.ADDEQUIPMENT.facilitymasterid = this.selectedFacilityID.value;
      //this.ADDEQUIPMENTParam.ADDEQUIPMENT.equipmentdesc = this.EquipmentTypeDescription.value; //Commented By Harikesh on 10-Oct-2020 for defect#12231
      this.sn = this.addresses[cot].sn;
      this.nickname = this.addresses[cot].nickname;
      this.IPAddress=this.addresses[cot].IPAddress
      this.orignalinstalldate = this.addresses[cot].Installdate;
      this.acculatorversion = this.addresses[cot].Accutator;
      this.functionalversion = this.addresses[cot].Functional
      this.PMType = this.addresses[cot].PMType
      this.LastPMDate = this.addresses[cot].LastPMDate;
      this.description = this.addresses[cot].description;
      this.GeneralSoftware = this.addresses[cot].GeneralSoftware;
      this.ADDEQUIPMENTParam.ADDEQUIPMENT.EQUIPMENTSERIALNUMBER = this.sn;
      this.ADDEQUIPMENTParam.ADDEQUIPMENT.MachineNickName = this.nickname;
      this.ADDEQUIPMENTParam.ADDEQUIPMENT.originalInstallDate = this.orignalinstalldate;
      this.ADDEQUIPMENTParam.ADDEQUIPMENT.ActuatorVersion = this.acculatorversion;
      this.ADDEQUIPMENTParam.ADDEQUIPMENT.FunctionalVersion = this.functionalversion;
      this.ADDEQUIPMENTParam.ADDEQUIPMENT.PMDATE = this.LastPMDate;
      this.ADDEQUIPMENTParam.ADDEQUIPMENT.GeneralSoftwareVersion = this.GeneralSoftware;
     this.ADDEQUIPMENTParam.ADDEQUIPMENT.MachineIPAddress=this.IPAddress;
     this.ADDEQUIPMENTParam.ADDEQUIPMENT.userid=this.userId;
     this.ADDEQUIPMENTParam.ADDEQUIPMENT.equipmentdesc = this.description; //Added By Harikesh on 10-Oct-2020 for defect#12231
     //COMMONDETAILS
     this.ADDEQUIPMENTParam.COMMONDETAILS.MODELNAME = this.selectedModelID.label;
     //CREATESERVICEREQUEST
     this.ADDEQUIPMENTParam.CREATESERVICEREQUEST.RequestSourceID = "";
     this.ADDEQUIPMENTParam.CREATESERVICEREQUEST.UserID=this.userId;
     this.ADDEQUIPMENTParam.CREATESERVICEREQUEST.FacilityMasterID =this.selectedFacilityID.value;
     this.ADDEQUIPMENTParam.CREATESERVICEREQUEST.WorkTypeID =1 ;
     this.ADDEQUIPMENTParam.CREATESERVICEREQUEST.SQACodeID=14;
     this.ADDEQUIPMENTParam.CREATESERVICEREQUEST.REQUESTDESCRIPTION = this.PMType.label;
      this.ADDEQUIPMENTParam.CREATESERVICEREQUEST.SQASUBCODEID=4;
      this.ADDEQUIPMENTParam.CREATESERVICEREQUEST.PMSEQUENCEID=this.PMType.value;
     this.ADDEQUIPMENTParam.GETPMSEQUENCE.sqaSubCodeId = 4;
    this.ADDEQUIPMENTParam.GETFACILITYINFO.facilityMasterId = this.selectedFacilityID.value;
    this.ADDEQUIPMENTParam.WRITEALERT.alertTypeId =5;
    this.ADDEQUIPMENTParam.WRITEALERT.alertObject="Service Request";
    this.ADDEQUIPMENTParam.WRITEALERT.OBJECTID = "";
    this.ADDEQUIPMENTParam.WRITEALERT.targetUserId =0;
    this.ADDEQUIPMENTParam.WRITEALERT.facilityMasterId =this.selectedFacilityID.value;
    this.ADDEQUIPMENTParam.WRITEALERT.regionMasterId = this.RegionName.value;
    this.ADDEQUIPMENTParam.WRITEALERT.divisionMasterId = this.DivisionName.value;
    this.ADDEQUIPMENTParam.WRITEALERT.alertPriorityId = 1;
    const dtToday = new Date()
    const tomorrow = new Date(dtToday)
    tomorrow.setDate(tomorrow.getDate() + 1)
    this.ADDEQUIPMENTParam.WRITEALERT.dateActive  =  dtToday;
    this.ADDEQUIPMENTParam.WRITEALERT.dateExpires = tomorrow;
    this.ADDEQUIPMENTParam.WRITEALERT.alertStatusId  = 4;
    this.ADDEQUIPMENTParam.WRITEALERT.ALERTDETAIL = "";
    this.ADDEQUIPMENTParam.WRITEALERT.isActiveFlag	= 1;
    this.ADDEQUIPMENTParam.WRITEALERT.userId  = this.userId;

      if (this.ADDEQUIPMENTParam != null) {
        this.isDisabled=true;
        var ADDEQUIPMENT = this.ADDEQUIPMENTParam;
        this._EquipmentService.addEquipment(JSON.stringify(ADDEQUIPMENT))
          .subscribe((addEquipmentResponse: any) => {
            {
              if (addEquipmentResponse.AddEquipment.length >0) {
                this.DeviceSave = true;
                this.isButtonVisible = true;
                this.istextBoxVisible = true;
                this.display = false;
              }
            }
          },
          (respose: Response) => {
            
            
          }
          );
      }
    }
  }

  callall() {
    this.isDisabled=false;
    this.disabledCombo = true;
    if(this.RowsNo>50)
    {
      this.messageService.showAlertMessage("Invalid Entry! Max number of Devices that can be added is 50.")
      this.disabledCombo = false;
      return false;
    }

    

    if (this.DivisionName == '' || this.DivisionName == undefined || this.DivisionName == null) {
     this.validationerror = true;
     this.disabledCombo = false;
     this.errormessage="Please select a Division.";     
      return false
    }
    if (this.RegionName == '' || this.RegionName == undefined || this.RegionName == null) {
      this.validationerror = true;
      this.disabledCombo = false;
      this.errormessage="Please select a Region.";
      return false
    }
    if (this.selectedFacilityID.value == '' || this.selectedFacilityID.value == undefined || this.selectedFacilityID.value == null) {
      this.validationerror = true;
      this.disabledCombo = false;
      this.errormessage="Please select a Location.";
      return false
    }
    if (this.selectedequipmentid == undefined || this.selectedequipmentid == null) {
      this.validationerror = true;
      this.errormessage="Please select an equipment Type.";
      return false
    }
    if (this.equipmentsubtypedescription == '' || this.equipmentsubtypedescription == undefined || this.equipmentsubtypedescription == null) {
      this.validationerror = true;
      this.disabledCombo = false;
      this.errormessage="Please select an equipment Sub-Type.";
      return false
    }
    if (this.equipmentTypeId == '' || this.equipmentTypeId == undefined || this.equipmentTypeId == null) {
      this.validationerror = true;
      this.disabledCombo = false;
      this.errormessage="Please select a Manufacturer.";
      return false
    }
    if (this.selectedModelID == '' || this.selectedModelID == undefined || this.selectedModelID == null) {
      this.validationerror = true;
      this.disabledCombo = false;
      this.errormessage=" Please select a Model.";
      return false
    }
    if (this.equipmentModalityId == '' || this.equipmentModalityId == undefined || this.equipmentModalityId == null) {
      this.validationerror = true;
      this.disabledCombo = false;
      this.errormessage="Please select a Modality.";
      return false
    }
    if (this.selectedConditionID == '' || this.selectedConditionID == undefined || this.selectedConditionID == null) {
      this.validationerror = true;
      this.disabledCombo = false;
      this.errormessage="Please select an equipment condition.";
      return false
    }
    if (this.selectedEquipmentStatusID == '' || this.selectedEquipmentStatusID == undefined || this.selectedEquipmentStatusID == null) {
      this.validationerror = true;
      this.disabledCombo = false;
      this.errormessage="Please select an equipment status.";
      return false
    }
    else{
      if(this.selectedEquipmentStatusID.label=="Active")
      {
       this.isActive=true;
      }
      else{
        this.isActive=false;
      }
    }
    if (this.RowsNo == '' || this.RowsNo == undefined || this.RowsNo == null) {
      this.validationerror = true;
      this.errormessage="Device Should not be blank";
      this.disabledCombo = false;
      return false
    }
    if (isNaN(this.RowsNo) || this.RowsNo==0) {
      this.validationerror = true;
      this.errormessage="The amount of devices is not a number";
      this.disabledCombo = false;
      return false
    }
        if ((this.selectedOriginID.value == 2 && this.selectedConditionID.value == 2) || (this.selectedOriginID.value == 2 && this.selectedConditionID.value == 3)) {
      this.isPMType = true;
    }
    else
    {
      this.isPMType = false;
    }
    this.prepareNicknameSoftwareModels();
    this.EquipmentSpecificInfo();
    this.isButtonVisible = false;
    this.istextBoxVisible = false;
  }


  public inputButton:any;
  public errorDialogButtonClicked() {
    
    // Solution for catching click events on anchors using querySelectorAll:
    this.inputButton = this.elementRef.nativeElement.querySelectorAll('input.btnAddEquipmentErrDialog');
    this.inputButton.forEach((anchor:HTMLButtonElement) => {
      anchor.addEventListener('click', this.handleAnchorClick)
    })
  }

  public ngOnDestroy() {
    // Cleanup by removing the event listeners on destroy
    if(this.inputButton!=null && this.inputButton!=undefined)
    {
    this.inputButton.forEach((anchor: HTMLButtonElement) => {
      anchor.removeEventListener('click', this.handleAnchorClick)
    })
  }
  }
  public handleAnchorClick = (event: Event) => 
  {
    
    // Prevent opening anchors the default way
      const anchor = event.target as HTMLButtonElement;
      let buttonId=anchor.id
      let arrSeial=buttonId.split("_");
      let sr=arrSeial[1];
      let btnType=arrSeial[2];
      console.log(this.addAddress.length);
      if(btnType=="OK")
      {
        for (let i = 0, size = this.addresses.length; i < size; i++)
        {
          if(i==Number(sr))
          {
            this.addresses[i].alertFlagField=1
          }
        }
      }
      let confirmBtn = '<input style="width:50px" type="button" class="ui-button btnAddEquipmentErrDialog" name="pmDateOK" id="pmDateOK_'+sr+'_OK" value="OK" class="errorButtons"/> <input type="button" name="pmDateCANCEL" style="width:60px" class="ui-button btnAddEquipmentErrDialog" id="pmDateCANCEL_'+sr+'_Cancel" value="Cancel" class="errorButtons"/>';
      this.nextButtonErrorMessage=this.nextButtonErrorMessage.replace(confirmBtn,"");
      setTimeout(() => {
        this.errorDialogButtonClicked();
      }, 200);
   }
}
